import tickCircleBlueIcon from "../../../assets/icons/tick-circle-blue.svg";

interface IOrderCompletedPage {
  currency: string;
  amount: number;
  title: string;
  successMessage: string;
}

export const OrderCompletedPage = (props: IOrderCompletedPage) => {
  return (
    <div className="order-completed--container flex-container justify-content--center align-items--center">
      <div className="flex-container col justify-content--center align-items--center">
        <div className="payment-completed-icon--container">
          <img
            src={tickCircleBlueIcon}
            alt="success"
            className="payment-completed--icon"
          />
        </div>

        <div className="flex-container col align-items--center ">
          <h4 className="step-title font-ctm--bold">{props.title}</h4>

          <p className="success-message">{props.successMessage}</p>
        </div>

        {/* <div className="payment-amount--container flex-box flex-container">
          <div className="flex-container">
            <strong>
              {props.currency} {props.amount}
            </strong>
          </div>
        </div> */}
      </div>
    </div>
  );
};
